import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Financial aid components
import FinancialAidBanner from 'components/account/Plans/FinancialAidBanner'
import FinancialAidInfo from 'components/account/Plans/FinancialAidInfo'
import FinancialAidApplicationModal from 'components/account/Plans/FinancialAidApplicationModal'

// shared components
import AccountButton from 'components/atoms/AccountButton'
import Camper from 'components/shared/Cart/Form/Camper'
import Summary from 'components/shared/Cart/Form/Summary'

// helpers
import { canSubmit } from 'lib/cart/decorators/cartForm'

const Form = props => {
  const {
    mutationLoading, // via withMutation
    account, // via withQuery
    session, // via withQuery
    sessions, // via withQuery
    refetchCart, // via withQuery
    cartForm, // via redux state
    inputErrors, // via withFormResults
    onClickSave, // via withEventHandlers
    onToggleDate // via withEventHandlers
  } = props

  const eligibleCampers = camper =>
    camper.confirmed || (camper.plans && camper.plans.length > 0)

  return (
    <>
      <FinancialAidBanner account={account} session={session} />

      {account.campers.filter(eligibleCampers).map(camper => (
        <Camper
          key={camper.id}
          camper={camper}
          account={account}
          sessions={sessions}
          cartForm={cartForm}
          inputErrors={inputErrors}
          onToggleDate={onToggleDate}
        />
      ))}

      <FinancialAidInfo account={account} sessions={sessions} />
      <FinancialAidApplicationModal
        sessions={sessions}
        refetchCart={refetchCart}
      />

      {cartForm && (
        <Box mb={4}>
          <Typography my={4} variant='h3' align='center'>
            Shopping Cart
          </Typography>
          <Summary account={account} sessions={sessions} cartForm={cartForm}>
            <Box my={2}>
              <AccountButton
                fullWidth
                disabled={
                  mutationLoading || !canSubmit({ account, cartForm, sessions })
                }
                variant='contained'
                color='secondary'
                onClick={onClickSave}
              >
                {mutationLoading ? 'Saving…' : 'Continue to Checkout'}
              </AccountButton>
            </Box>
          </Summary>
        </Box>
      )}
    </>
  )
}

export default Form
